'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Pagination = require('./Pagination');

var _Pagination2 = _interopRequireDefault(_Pagination);

var _Table = require('./Table');

var _Table2 = _interopRequireDefault(_Table);

var _Message = require('./Message');

var _Message2 = _interopRequireDefault(_Message);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Data = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Data, _React$Component);

  function Data() {
    (0, _classCallCheck3.default)(this, Data);
    return (0, _possibleConstructorReturn3.default)(this, (Data.__proto__ || Object.getPrototypeOf(Data)).apply(this, arguments));
  }

  (0, _createClass3.default)(Data, [{
    key: 'renderLoading',
    value: function renderLoading() {
      if (!this.props.loadingComponent) return _react2.default.createElement('span', null);
      return _react2.default.createElement(this.props.loadingComponent, null);
    }
  }, {
    key: 'renderNotFound',
    value: function renderNotFound() {
      return _react2.default.createElement(_Message2.default, { message: 'No items found' });
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      var message = 'Error';
      if (this.props.data.error && this.props.data.error.graphQLErrors && this.props.data.error.graphQLErrors[0]) {
        message = this.props.data.error.graphQLErrors[0].message;
      }
      return _react2.default.createElement(_Message2.default, { message: message });
    }
  }, {
    key: 'renderTable',
    value: function renderTable() {
      if (this.props.debouncing) return this.renderLoading();
      if (this.props.data.loading) return this.renderLoading();
      if (!this.props.data.result.items || this.props.data.result.items.length === 0) {
        return this.renderNotFound();
      }
      return _react2.default.createElement(
        'div',
        { ref: 'items' },
        _react2.default.createElement(_Table2.default, {
          sortBy: this.props.sortBy,
          sortType: this.props.sortType,
          setSort: this.props.setSort,
          onSelect: this.props.onPress,
          selectedItemId: this.props.selectedItemId,
          items: this.props.data.result.items,
          fields: this.props.fields
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.data.result) {
        if (this.props.data.networkStatus === 1 && Object.keys(this.props.data).length === 10 || this.props.data.networkStatus === 2) {
          return this.renderLoading();
        } else {
          return this.renderError();
        }
      }
      return _react2.default.createElement(
        'div',
        { className: 'paginated-container box' },
        this.renderTable(),
        _react2.default.createElement(_Pagination2.default, (0, _extends3.default)({}, this.props, { result: this.props.data.result }))
      );
    }
  }]);
  return Data;
}(_react2.default.Component), _class.propTypes = {
  data: _propTypes2.default.object,
  fields: _propTypes2.default.array,
  onPress: _propTypes2.default.func,
  sortBy: _propTypes2.default.string,
  sortType: _propTypes2.default.string,
  setSort: _propTypes2.default.func,
  debouncing: _propTypes2.default.bool,
  selectedItemId: _propTypes2.default.string,
  loadingComponent: _propTypes2.default.any
}, _temp);
exports.default = Data;


//////////////////
// WEBPACK FOOTER
// ./node_modules/meteor-paginated-graphql-react/lib/Data.js
// module id = 1523
// module chunks = 85